<div class="tacho-filter-container">

    <button #select__toggle class="select__toggle" [ngClass]="{'select__toggle--rotated': showList}" (click)="toggleShowList()"
        (blur)="closeShowList()">
        <div class="select__toggle__icon"></div>
    </button>

    <!-- elementy -->
    <div class="filter-items-container" *ngIf="showList === true">

        <ul class="filter-items">

            <li class="filter-item">
                <div (click)="resetValue()">
                    <span class="filter-icon filter-icon-current"></span>
                    <span class="filter-item-label">
                        Aktualny stan
                    </span>
                </div>
            </li>

            <li class="filter-item">
                <div (click)="selectAll()">
                    <span class="filter-icon filter-icon-all"></span>
                    <span class="filter-item-label">
                        Wszystkie stany
                    </span>
                </div>
            </li>

            <li class="filter-item" [ngClass]="{'selected' : currentValues.indexOf('driving') !== -1}">
                <div (click)="onSelect('driving')">
                    <span class="filter-icon filter-icon-driving"></span>
                    <span class="filter-item-label">
                        Jadą
                    </span>
                </div>
            </li>


            <li class="filter-item" [ngClass]="{'selected' : currentValues.indexOf('working') !== -1}">
                <div (click)="onSelect('working')">
                    <span class="filter-icon filter-icon-working"></span>
                    <span class="filter-item-label">
                        Pracują
                    </span>
                </div>
            </li>

            <li class="filter-item" [ngClass]="{'selected' : currentValues.indexOf('resting') !== -1}">
                <div (click)="onSelect('resting')">
                    <span class="filter-icon filter-icon-resting"></span>
                    <span class="filter-item-label">
                        Odpoczywają
                    </span>
                </div>
            </li>

            <li class="filter-item" [ngClass]="{'selected' : currentValues.indexOf('free') !== -1}">
                <div (click)="onSelect('free')">
                    <span class="filter-icon filter-icon-free"></span>
                    <span class="filter-item-label">
                        Dyspozycyjność
                    </span>
                </div>
            </li>


        </ul>

    </div>
</div>